import { styled } from '@mui/material/styles';

export const Form = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '23px',
  maxWidth: '410px',
  width: '100%',

  button: {
    marginBottom: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    gap: '15px',
  },
}));
